import { EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Directive } from '@angular/core';
import { TimelineMax } from 'gsap';
import { ElementRef } from '@angular/core';
import { Power2 } from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


@Directive({
  selector: '[appFadeInDirective]'
})
export class FadeInDirectiveDirective implements OnInit {

  @Input() duration = 1;
  @Input() delay = 0;
  @Input() trigger: any;

  @Output() complete: EventEmitter<null> = new EventEmitter();
  @Output() reverseComplete: EventEmitter<null> = new EventEmitter();
  protected timeline: TimelineMax;

  constructor(protected element: ElementRef) {

    this.timeline = new TimelineMax({
      onComplete: _ => this.complete.emit(),
      onReverseComplete: _ => this.reverseComplete.emit(),
      paused:true,
      reversed:true
    });
  }

  ngOnInit() {
    // perform animation
    this.animateIn();
  }

  protected animateIn() {

    this.timeline.set(this.element.nativeElement, {x:300})

    this.timeline.from(
      this.element.nativeElement, 
      this.duration, 
      {
        scrollTrigger: this.trigger,
        start: "top top",
        opacity:'0',
        ease:Power2.easeInOut,
        x:300
      },
       this.delay);

    this._animateIn();
  }

  protected _animateIn() {

    this.timeline.set(this.element.nativeElement, {x:300})

    if(this.timeline.isActive()) {
      this.timeline.kill();
    }
    this.timeline.play();
  }

}
